// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3_6db","title":"ClientInsurance_title__1YHzq","itemText":"ClientInsurance_itemText__25gt_"};